import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueRouter from 'vue-router'
import TooltipPlugin from 'bootstrap-vue'
import MaskedInput from 'vue-masked-input'

// import route from 'route'

Vue.use(TooltipPlugin);
Vue.prototype.$http = axios;
Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.component('masked-input', MaskedInput);

new Vue({
  render: h => h(App),
}).$mount('#app');
